
const NewsSection = () => {
  const news = [
    {
      date: '2026.01.06',
      title: '성도재일 법회',
      summary: '동지를 맞이하여 특별 기도법회를 봉행합니다. 가족의 건강과 평안을 기원하는 뜻깊은 시간이 되시길 바랍니다.',
      link: '/dharma'
    },
    {
      date: '2026.01.16',
      title: '지장재일',
      summary: '천년 역사를 간직한 성덕사의 이야기를 담은 역사관이 새롭게 문을 열었습니다. 많은 관심과 방문 부탁드립니다.',
      link: '/dharma'
    },
    {
      date: '2026.01.22',
      title: '관음재일',
      summary: '겨울 템플스테이 프로그램이 시작됩니다. 고요한 겨울 사찰에서 마음의 평화를 찾아보세요.',
      link: '/dharma'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-stone-50 to-amber-50/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-800">최신 소식</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {news.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm hover:shadow-lg transition-shadow duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="p-8">
                <p className="text-sm text-gray-500 mb-3">{item.date}</p>
                <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-teal-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6 line-clamp-3">
                  {item.summary}
                </p>
                <a
                  href={item.link}
                  className="inline-flex items-center space-x-2 text-teal-600 font-medium group-hover:gap-3 transition-all whitespace-nowrap"
                >
                  <span>자세히 보기</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
